module.exports = __webpack_public_path__ + "img/img3.fa7408d0.jpg";